import { render, staticRenderFns } from "./BasicTable.vue?vue&type=template&id=5f24ee63&scoped=true&"
import script from "./BasicTable.vue?vue&type=script&lang=ts&"
export * from "./BasicTable.vue?vue&type=script&lang=ts&"
import style0 from "./BasicTable.vue?vue&type=style&index=0&id=5f24ee63&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f24ee63",
  null
  
)

export default component.exports